import './app.css';
import '@babel/polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import WebFont from 'webfontloader';
import makeSectionLikePaper from './js/makeSectionLikePaper';
import nanoModal from 'nanomodal';
import mediator from './js/mediator';
import Sandwich from './js/sandwich';
import * as VanillaSharing from 'vanilla-sharing';
import analyticsEvent from './js/analytics-event';
import meta from './js/meta';
import isMobile from 'ismobilejs';
import getAllUrlParams from './getAllUrlParams';
import animations from './js/animations';
import debounce from 'debounce';


const isProd = process.env.NODE_ENV === 'production'

smoothscroll.polyfill();

// buy ticket
{
    const links = Array.from(document.querySelectorAll('[data-action="buy"]'));

    links.forEach(link => {
        link.addEventListener('click', () => {
            if (isMobile.any) {
                return;
            }

            event.preventDefault();
            window.ticketManager.movieSchedule(92879);
        });
    });
}

// share 
{

    const shareButtons = [...document.querySelectorAll('.share__item')];

    if (shareButtons.length > 0) {

        const shareOptions = {
            url: meta.url,
            title: meta.title,
            description: meta.description,
            image: meta.image,
            isVkParse: false,
            fbAppId: meta.fbappid
        };

        shareButtons.forEach(button => {
            button.addEventListener('click', () => {
                if (button.dataset.social === 'all' && navigator.share !== undefined) {
                    navigator.share({
                        title: shareOptions.title,
                        url: shareOptions.url
                    });
                } else {
                    VanillaSharing[button.dataset.social](shareOptions);
                }
                analyticsEvent('Share', 'click', 'Social: ' + button.dataset.social);
            });
        });

    }
}

// analytics
{
    const trackingElements = document.querySelectorAll('[data-event][data-event-category][data-event-label]');

    if (trackingElements.length > 0) {
        trackingElements.forEach(trackingElem => {
            trackingElem.addEventListener(trackingElem.getAttribute('data-event'), () => {
                analyticsEvent(
                    trackingElem.getAttribute('data-event-category'),
                    trackingElem.getAttribute('data-event'),
                    trackingElem.getAttribute('data-event-label')
                );
            });
        });
    }
}

// font
{
    WebFont.load({
        custom: {
            families: ['Activist:n4', 'Rodchenko:n4'],
            urls: ['./css/fonts.css']
        }
    });
}

// ancors
{
    const links = Array.from(document.querySelectorAll('[data-scroll-to]'));

    links.forEach(link => {
        const clickHandler = event => {
            event.preventDefault();

            const id = (/^#([a-zA-Z_]+)$/).exec(link.getAttribute('href'))[1];
            const target = document.getElementById(id);

            if (!target) {
                return;
            }

            let gap = 100;
            gap = id === 'about' ? gap - 100 : gap;

            const scrollY = target.offsetTop - gap;

            window.scroll({
                top: scrollY,
                behavior: 'smooth'
            });
        };

        link.addEventListener('click', clickHandler);
    });
}



// paper scroll
{
    const s1 = document.getElementById('section-1');
    const s2 = document.getElementById('section-2');
    const s2_1 = document.getElementById('section-2-1');
    const s3 = document.getElementById('section-3');

    const destroyArr = [];

    const set = () => {
        s1.style.zIndex = 5;
        destroyArr.push(makeSectionLikePaper(s2, {prevElement: s1, gapBackground: '#47372a', gapOpacity: 0.65, hook: 0.25}));
        destroyArr.push(makeSectionLikePaper(s2_1, {prevElement: s2, gapBackground: '#47372a', gapOpacity: 0.65, hook: 0.25}));
        destroyArr.push(makeSectionLikePaper(s3, {prevElement: s2_1, gapBackground: '#47372a', gapOpacity: 0.65, hook: 0.25}));
    };

    const unset = () => {
        destroyArr.forEach(destroy => destroy());
        destroyArr.splice(0, destroyArr.length);
    };

    const rebuild = () => {
        unset();
        set();
    };


    set();
    window.addEventListener('resize', rebuild);
}


// trailer switch
{
    const section1 = document.querySelector('.section__content--1');
    const section2 = document.querySelector('.section__content--2');
    const sections = [section1, section2];

    const trailerButtons = Array.from(document.querySelectorAll('.button--trailer'));
    const rolesButtons = Array.from(document.querySelectorAll('.button--roles'));

    const showSection = section => {
        sections.forEach(section => section.style.display = 'none');
        section.style.display = 'block';

        if (section === section2) {
            delete document.body.dataset.trailer;
            document.body.dataset.actors = 'shown';
        } else if (section === section1) {
            delete document.body.dataset.actors;
            document.body.dataset.trailer = 'shown';
        } else {
            delete document.body.dataset.trailer;
            delete document.body.dataset.actors;
        }

    };

    showSection(sections[0]);

    trailerButtons.forEach(button => {
        button.addEventListener('click', () => showSection(section1));
    });

    rolesButtons.forEach(button => {
        button.addEventListener('click', () => showSection(section2));
    });
}


// modal
{

    const buttonElements = Array.from(document.querySelectorAll('[data-form]'));

    nanoModal.customShow = function (defaultShow, modalAPI) {
        defaultShow();

        modalAPI.overlay.el.style.width = window.innerWidth + 'px';
        modalAPI.overlay.el.style.height = window.innerHeight + 'px';

        modalAPI.modal.el.style.marginLeft = 0;
        modalAPI.modal.el.style.marginRight = 0;

        modalAPI.modal.el.style.width = window.innerWidth + 'px';
        modalAPI.modal.el.style.height = window.innerHeight + 'px';

        modalAPI.modal.el.style.background = 'transparent';
    };

    const init = () => {
        if (!buttonElements.length) {
            return;
        }

        const showSuccessModal = number => {
            const modalElement = document.getElementById('modal-2');
            const closes = Array.from(modalElement.querySelectorAll('._close'));

            const modal = nanoModal(modalElement, {
                overlayClose: true,
                buttons: [],
                autoRemove: true
            });

            modal.onShow(() => {
                document.body.classList.add('noscroll');
                setTimeout(() => {
                    modal.modal.el.classList.add('fade-in');

                    const numberSpan = modal.modal.el.querySelector('.m-number');
                    numberSpan.innerText = number;
                }, 50);
            });

            modal.onHide(() => {
                document.body.classList.remove('noscroll');
            });


            closes.forEach(close => {
                const closeHandler = () => {
                    modal.hide();
                    close.removeEventListener('click', closeHandler);
                };

                close.addEventListener('click', closeHandler);
            })

            modal.show();
        };

        buttonElements.forEach(button => {
            const formId = button.dataset.form;
            const modalElement = document.getElementById('form-modal-' + formId);

            button.addEventListener('click', () => {

                // if (new Date() < new Date(2018, 3, 5)) {
                //     showModal1();
                //     return;
                // }

                const modal = nanoModal(modalElement, {
                    overlayClose: true,
                    buttons: [],
                    autoRemove: true
                });

                modal.onShow(() => {
                    document.body.classList.add('noscroll');
                    setTimeout(() => {
                        modal.modal.el.classList.add('fade-in');
                    }, 50);
                });

                modal.onHide(() => {
                    document.body.classList.remove('noscroll');
                });

                modal.show();

                let mediatorHandler = (number = 'X') => {
                    modal.hide();
                    mediator.remove('modal:form-1:success', mediatorHandler);
                    mediatorHandler = null;
                    showSuccessModal(number);
                };

                mediator.subscribe('modal:form-1:success', mediatorHandler);
            });
        });
    };

    init();
}

/* {
    const form = document.forms['form-1'];
    const inputs = {
        username: form.elements['username'],
        email: form.elements['email'],
        type: form.elements['type'],
        number: form.elements['number'],
        cinema: form.elements['cinema']
    };

    const setInputsValid = () => {
        Object.keys(inputs).forEach(prop => {
            const label = inputs[prop].parentElement;
            const description = label.querySelector('.form__error');
            label.classList.remove('form__label--invalid');
            description.innerText = '';
        });
    };

    const setInputInvalid = (prop, message) => {
        if (typeof inputs[prop] === 'undefined') {
            return;
        }

        const label = inputs[prop].parentElement;
        const description = label.querySelector('.form__error');

        label.classList.add('form__label--invalid');
        description.innerText = message;
    };

    const resetModal = () => {
        setInputsValid();
        form.reset();
    };

    setInputsValid();

    const submitHandler = event => {
        event.preventDefault();

        let url = form.getAttribute('action');
        const method = form.getAttribute('method');

        const validate = data => {
            if (typeof data.id !== 'undefined') {
                return true;
            } else {
                setInputsValid();
                data.forEach(prop => {
                    Object.keys(prop).forEach(key => {
                        if (prop[key].indexOf('1') !== -1) {
                            setInputInvalid(key, 'заполнить обязательно');
                        } else if (prop[key].indexOf('2') !== -1) {
                            setInputInvalid(key, 'не уникальный');
                        } else if (key === 'email' && prop.email.indexOf('40') !== -1) {
                            setInputInvalid(key, 'Превышена длинна ящика');
                        } else if (key === 'username' && prop.username.indexOf('150') !== -1) {
                            setInputInvalid(key, 'Превышена длинна имени');
                        } else if (prop[key].indexOf('255') !== -1) {
                            setInputInvalid(key, 'Превышена длинна');
                        }
                    });

                });
            }
        };

        let queryString = `username=${encodeURI(inputs.username.value)}`;
        queryString += `&email=${encodeURI(inputs.email.value)}`;
        queryString += `&type=${encodeURI(inputs.type.options[inputs.type.selectedIndex].text)}`;
        queryString += `&number=${encodeURI(inputs.number.value)}`;
        queryString += `&cinema=${encodeURI(inputs.cinema.options[inputs.cinema.selectedIndex].text)}`;

        url += '?' + queryString;

        url, resetModal, method, validate;
        fetch(url, {
            method
        }).then(response => {
            return response.json();
        }).then(data => {

            if (validate(data)) {
                resetModal();
                if (typeof data.id !== 'undefined') {
                    mediator.publish('modal:form-1:success', data.id);
                } else {
                    mediator.publish('modal:form-1:success');
                }
            }
        });
    };

    form.addEventListener('submit', submitHandler);
} */



{
    const buttonRoot = document.getElementById('sandwich');
    let sandwich;

    const animation = {
        elements: Array.from(document.querySelectorAll('.mobile-menu .menu__pop-up .pop-up__links .a-reveal')),
        socialElements: Array.from(document.querySelectorAll('.mobile-menu .menu__pop-up .share-list .a-reveal')),
        timeout: 125
    };

    const menuLinks = Array.from(document.querySelectorAll('.mobile-menu .menu__pop-up a'));

    const openAnimation = () => {
        setTimeout(() => {
            animation.elements.forEach((elem, index) => {
                setTimeout(() => {
                    elem.classList.add('a-reveal-done')
                }, animation.timeout * (index + 1));
            });

            animation.socialElements.forEach((elem, index) => {
                setTimeout(() => {
                    elem.classList.add('a-reveal-done')
                }, animation.timeout * (index + 1));
            });
        }, 300);
    };

    const closeAnimation = () => {
        animation.elements.forEach(elem => {
            setTimeout(() => {
                elem.classList.remove('a-reveal-done');
            }, 300);
        });
        animation.socialElements.forEach(elem => {
            setTimeout(() => {
                elem.classList.remove('a-reveal-done');
            }, 300);
        });
    };

    if (buttonRoot) {
        sandwich = new Sandwich(buttonRoot);
        sandwich.opened = document.body.dataset.menuMobile === 'opened' ? true : false;

        sandwich.on('toggle', status => {
            document.body.dataset.menuMobile = status;
        });

        sandwich.on('open', () => {
            openAnimation();
        });

        sandwich.on('close', () => {
            closeAnimation();
        });
    }

    menuLinks.forEach(link => {
        const clickHandler = () => {
            sandwich.opened = false;
        };

        link.addEventListener('click', clickHandler);
    });
}



// service worker
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}



{

    const section = getAllUrlParams().s;
    let scrollY = 0;

    if (section) {
        const element = document.getElementById('section-' + section);
        if (element) {
            const rect = element.getBoundingClientRect();
            scrollY = rect.top + window.scrollY;
            scrollY = section === '1' ? scrollY - 100 : scrollY;

            window.scroll(0, scrollY);
            setTimeout(() => {
                window.scroll(0, scrollY);
            }, 1000);
        }
    }
}


{
    const tab = document.getElementById('tab-1');

    let lastScrollTop = 0;
    let direction;

    const detectDirection = () => {
        const st = window.pageYOffset || document.documentElement.scrollTop;
        const direction = st > lastScrollTop ? 'down' : 'up';
        lastScrollTop = st;

        return direction;
    };

    if (tab) {
        const tabAnimations = new animations.Tab(tab);
        tab.style.transform = 'translate3d(-120%, -10%, 0) scale(1.2) rotate(-25deg)';

        setTimeout(() => {
            tabAnimations.show.play();
        }, 500);

        const scrollDirectionHandler = () => {
            direction = detectDirection();
        };

        const scrollHandler1 = () => {
            if (direction === 'up') {
                tabAnimations.floatDown.play();
            } else if (direction === 'down') {
                tabAnimations.floatUp.play();
            }
        };

        const scrollHandler2 = () => {
            tabAnimations.floatBack.play();
        };

        const scrollStartHandler = debounce(scrollHandler1, 250, true);
        const scrollEndHandler = debounce(scrollHandler2, 250, false);

        window.addEventListener('scroll', scrollDirectionHandler, false);
        window.addEventListener('scroll', scrollStartHandler, false);
        window.addEventListener('scroll', scrollEndHandler, false);
    }
}


// WEBPACK FOOTER //
// ./app.js